import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AUTH_LOCAL_STORAGE_KEY } from '../container/screen/Auth/logic/constants';

export const Service = createApi({
  reducerPath: 'Services',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_API_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
      if (!headers.has('Content-Type')) {
        headers.set('Content-Type', 'application/json');
      }
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ['EquityConfig', 'EquityAllocation', 'EquityCapitalCall', 'EquityObligation', 'AgreementTemplate'],
  endpoints: (builder) => ({
    getFormConfig: builder.query<any, void>({
      query: (arg: any) => {
        const { formName } = arg;
        return {
          method: 'GET',
          url: `/v2/product-engine/form/${formName}`,
        };
      },
    }),
    submitForm: builder.mutation<any, any>({
      query: (body: any) => {
        return {
          method: body.submitMethod,
          url: body.submitEndpoint,
          body: body.payload,
        };
      },
    }),
    getSignedUploadUrl: builder.mutation<{ url: string; path: string }, { fileName: string; fileType?: string }>({
      query: (body) => {
        return {
          method: 'POST',
          url: '/v2/file-manager/signed-upload',
          body,
        };
      },
    }),
    getSignedImageUploadUrl: builder.mutation<{ url: string; path: string }, { fileName: string; fileType?: string }>({
      query: (body) => {
        return {
          method: 'POST',
          url: '/v2/file-manager/signed-image-upload',
          body,
        };
      },
    }),
    getList: builder.query<any, any>({
      query: (arg: any) => {
        const { endpoint } = arg;
        return {
          method: 'GET',
          url: endpoint,
        };
      },
    }),
    getInvitationList: builder.query<any, void>({
      query: (arg: any) => {
        const { senderType, senderId } = arg;
        return {
          method: 'GET',
          url: `/v2/invitations/by/${senderType}/${senderId}`,
        };
      },
    }),
  }),
});

export const {
  injectEndpoints,
  useGetFormConfigQuery,
  useSubmitFormMutation,
  useGetSignedUploadUrlMutation,
  useGetSignedImageUploadUrlMutation,
  useLazyGetListQuery,
  useGetInvitationListQuery,
  useLazyGetFormConfigQuery,
} = Service;
